import { useCallback, useRef } from 'react'
import en from '../../languages/en.json'
import pt from '../../languages/pt.json'
import { useGetMyProfile } from '../queries/profile/use-get-my-profile'

const languages = {
  en,
  pt,
}

export type Language = keyof typeof en

export function useTranslate() {
  const { user } = useGetMyProfile()

  const language = useRef(navigator.language)

  const handleCheckUserLanguage = useCallback(() => {
    const navigatorLanguage = language.current.includes('-')
      ? language.current.split('-').at(0)
      : language.current

    const userLanguage = {
      br: 'pt',
      pt: 'pt',
      en: 'en',
      us: 'en',
    }

    return (
      userLanguage[user?.language as keyof typeof userLanguage] ||
      navigatorLanguage ||
      'en'
    )
  }, [user?.language])

  const translate = useCallback(
    (word: Language, replaceValue?: string | number) => {
      const currentLanguage = handleCheckUserLanguage()

      const currentIdiom =
        languages[currentLanguage as keyof typeof languages] || languages['en']

      const wordValue = currentIdiom[word] || word

      if (['string', 'number'].includes(typeof replaceValue)) {
        return wordValue.replace('{{value}}', String(replaceValue))
      }

      return wordValue
    },
    [handleCheckUserLanguage],
  )

  return { translate }
}
